export default __webpack_public_path__ + "images/bb68cce79d5e28fcd85dce0eca39c112-illustration.svg";